// core four bundle image gallery
(function () {
  var img = document.getElementById('arpy-cf-image');
  var dotsWrap = document.getElementById('arpy-cf-dots');
  if (!img || !dotsWrap) return;

  // pull the core-four product's images from admin (data-cf-images, rendered
  // by Liquid); fall back to the original bundle shots if the product has none
  var images = (img.getAttribute('data-cf-images') || '').split('|').filter(Boolean);
  if (!images.length) {
    images = [
      'https://cdn.shopify.com/s/files/1/0752/6200/1326/files/tcrslidev2.1.png?v=1781590059&width=1000',
      'https://cdn.shopify.com/s/files/1/0752/6200/1326/files/tcrslidev2.png?v=1781590098&width=1000'
    ];
  }
  var active = 0;
  var startX = 0;

  function set(i) {
    if (!images[i]) return;
    active = i;
    img.style.backgroundImage = "url('" + images[i] + "')";
    dotsWrap.querySelectorAll('.arpy-cf-dot').forEach(function (d, n) {
      d.classList.toggle('is-active', n === active);
    });
  }

  function buildDots() {
    dotsWrap.innerHTML = '';
    if (images.length <= 1) {
      dotsWrap.parentElement.style.display = 'none';
      return;
    }
    images.forEach(function (_, i) {
      var b = document.createElement('button');
      b.className = 'arpy-cf-dot' + (i === 0 ? ' is-active' : '');
      b.type = 'button';
      b.setAttribute('aria-label', 'view image ' + (i + 1));
      b.addEventListener('click', function () { set(i); });
      dotsWrap.appendChild(b);
    });
  }

  img.addEventListener('touchstart', function (e) {
    startX = e.changedTouches[0].screenX;
  }, { passive: true });

  img.addEventListener('touchend', function (e) {
    var d = e.changedTouches[0].screenX - startX;
    if (Math.abs(d) < 45) return;
    if (d < 0) set(active + 1 >= images.length ? 0 : active + 1);
    else set(active - 1 < 0 ? images.length - 1 : active - 1);
  }, { passive: true });

  buildDots();
  set(0);
})();

// hero texture tile — tap to reveal label on touch devices
(function () {
  var tiles = document.querySelectorAll('.arpy-hero-tile');
  if (!tiles.length) return;
  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      var active = tile.classList.contains('is-tapped');
      tiles.forEach(function (t) { t.classList.remove('is-tapped'); });
      if (!active) tile.classList.add('is-tapped');
    });
  });
})();

// routine pill switching
document.querySelectorAll('.arpy-routine-list').forEach(function (routine) {
  var pills = routine.querySelectorAll('.arpy-routine-pill');
  var detailTop = routine.querySelector('.arpy-routine-detail-top');
  var marker = routine.querySelector('#arpy-routine-detail-marker');
  var step = routine.querySelector('#arpy-routine-detail-step');
  var title = routine.querySelector('#arpy-routine-detail-title');
  var description = routine.querySelector('#arpy-routine-detail-description');
  var price = routine.querySelector('#arpy-routine-detail-price');
  var link = routine.querySelector('#arpy-routine-detail-link');

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.classList.contains('is-active')) return;

      pills.forEach(function (item) { item.classList.remove('is-active'); });
      pill.classList.add('is-active');

      detailTop.style.opacity = '0';
      detailTop.style.transform = 'translateY(-8px)';

      setTimeout(function () {
        marker.style.background = pill.getAttribute('data-marker');
        step.textContent = pill.getAttribute('data-step');
        step.style.color = pill.getAttribute('data-marker');
        title.textContent = pill.getAttribute('data-title');
        description.textContent = pill.getAttribute('data-description');
        price.textContent = pill.getAttribute('data-price');

        if (link) {
          link.href = pill.getAttribute('data-link');
          link.textContent = pill.getAttribute('data-cta');
          link.style.setProperty('--detail-accent', pill.getAttribute('data-marker'));
        }

        detailTop.style.transform = 'translateY(12px)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            detailTop.style.opacity = '1';
            detailTop.style.transform = 'translateY(0)';
          });
        });
      }, 120);
    });
  });
});

// scroll-triggered entrance animations
(function () {
  var animatables = document.querySelectorAll('.arpy-animate-in');
  if (!animatables.length) return;

  if (!('IntersectionObserver' in window)) {
    animatables.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-animate-delay') || '0', 10);
      setTimeout(function () { el.classList.add('is-visible'); }, delay);
      observer.unobserve(el);
    });
  }, { threshold: 0.12 });

  animatables.forEach(function (el) { observer.observe(el); });
})();

// add to cart — handles data-arpy-add-handle buttons (homepage cards + core four bundle)
document.querySelectorAll('[data-arpy-add-handle]').forEach(function (button) {
  button.addEventListener('click', function () {
    var handle = button.getAttribute('data-arpy-add-handle');
    if (!handle) return;

    var original = button.textContent;
    button.textContent = 'adding...';
    button.disabled = true;

    fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product not found');
        return response.json();
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          throw new Error('no variant found');
        }

        var variant = product.variants.find(function (item) {
          return item.available;
        }) || product.variants[0];

        if (!variant || !variant.available) {
          button.textContent = 'sold out';
          button.disabled = true;
          return null;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        });
      })
      .then(function (response) {
        if (!response) return null;
        if (!response.ok) throw new Error('add to cart failed');
        return response.json();
      })
      .then(function (item) {
        if (!item) return;

        button.textContent = 'added';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1600);
      })
      .catch(function () {
        button.textContent = 'try again';
        button.disabled = false;
      });
  });
});

// real-life strip — arrow scrolling
(function () {
  var strip = document.querySelector('.arpy-real-strip');
  var prev = document.querySelector('.arpy-real-nav-prev');
  var next = document.querySelector('.arpy-real-nav-next');
  if (!strip || !prev || !next) return;

  function step() {
    var shot = strip.querySelector('.arpy-real-shot');
    return shot ? shot.offsetWidth + 11 : 280;
  }
  function update() {
    prev.disabled = strip.scrollLeft <= 2;
    next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
  }
  prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
  strip.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
